/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_BlockedInputs */

const cs_templates_branding_blocked = /** @type {(inputs: Templates_Branding_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Není připraveno`)
};

const en_templates_branding_blocked = /** @type {(inputs: Templates_Branding_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not ready`)
};

/**
* | output |
* | --- |
* | "Not ready" |
*
* @param {Templates_Branding_BlockedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_blocked = /** @type {((inputs?: Templates_Branding_BlockedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_BlockedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_blocked(inputs)
	return cs_templates_branding_blocked(inputs)
});